import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ListaProyectosComponent} from "./components/lista-proyectos/lista-proyectos.component";
import {InfoServiciosProyectoComponent} from "./components/info-tramites-proyecto/info-tramites-proyecto.component";
import {NuevoProyectoComponent} from "./components/nuevo-proyecto/nuevo-proyecto.component";
import {
    GeneralidadesNuevoProyectoComponent
} from "./components/nuevo-proyecto/components/generalidades-nuevo-proyecto/generalidades-nuevo-proyecto.component";
import {
    UbicacionProyectoComponent
} from "./components/nuevo-proyecto/components/ubicacion-proyecto/ubicacion-proyecto.component";
import {
    PersonasProyectoComponent
} from "./components/nuevo-proyecto/components/personas-proyecto/personas-proyecto.component";
import {ProyectosRoutingModule} from "./proyectos-routing.module";
import {PrimeNgModule} from "../../shared/prime-ng/prime-ng.module";
import {PerfilModule} from "../perfil/perfil.module";
import {MenuModule} from "primeng/menu";
import {RippleModule} from "primeng/ripple";
import {GeneralesProyectoComponent} from "./components/ver-proyecto/generales-proyecto/generales-proyecto.component";
import {FileUtilsService} from "../../shared/services/file-utils-service";
import {VerProyectoComponent} from "./components/ver-proyecto/ver-proyecto.component";
import {
    TramitesPorProyectoComponent
} from "./components/info-tramites-proyecto/tramites-por-proyecto/tramites-por-proyecto.component";
import {SharedModule} from "../../shared/shared.module";
import {AssignedUsersComponent} from "../../officials/asignaciones/components/assigned-users/assigned-users.component";
import {InputGroupModule} from "primeng/inputgroup";
import {InputGroupAddonModule} from "primeng/inputgroupaddon";
import {InputSwitchModule} from "primeng/inputswitch";
import {GeneralesResumenComponent} from "./components/ver-proyecto/generales-resumen/generales-resumen.component";
import {EventsBoardComponent} from "./components/ver-proyecto/events-board/events-board.component";
import {SkeletonModule} from "primeng/skeleton";
import {PdfJsViewerModule} from "ng2-pdfjs-viewer";
import {
    InfoDialogRequisitosComponent
} from "../../shared/components/requisitos-informacion/info-dialog-requisitos/info-dialog-requisitos.component";
import {
    SolicitudRequisitosComponent
} from "../../shared/components/solicitud-requisitos/solicitud-requisitos.component";
import {
    RequisitosInformacionComponent
} from "../../shared/components/requisitos-informacion/requisitos-informacion.component";
import {
    ArchivoVigenteComponent
} from "./components/nuevo-proyecto/components/archivo-vigente/archivo-vigente.component";
import {UsuarioDialogComponent} from "../mnto-usuarios/components/usuarios/usuario-dialog/usuario-dialog.component";
import {IconFieldModule} from "primeng/iconfield";
import {InputIconModule} from "primeng/inputicon";
import {ViewerImgComponent} from "../../shared/components/viewer-img/viewer-img.component";
import {ViewerPdfComponent} from "../../shared/components/viewer-pdf/viewer-pdf.component";
import {KeyFilterModule} from "primeng/keyfilter";
import {
    PasosPersonasProyectosComponent
} from "../../shared/components/pasos-personas-proyectos/pasos-personas-proyectos.component";
import {
    FormGroupBuilderService
} from "../../shared/components/solicitud-requisitos/rq-form/services/form-group-builder.service";
import {FieldsParserService} from "../../shared/components/solicitud-requisitos/rq-form/services/fields-parser.service";
import {DraftProjectService} from "./services/draft-project.service";
import {ConfirmPopupModule} from "primeng/confirmpopup";
import {StyleClassModule} from "primeng/styleclass";
import {
    DictamenesEvaluacionComponent
} from "../../officials/evaluaciones/components/dictamenes-evaluacion/dictamenes-evaluacion.component";
import {KnopComponent} from "../../shared/components/knop/knop.component";
import {
    FaseTramiteEvaluacionComponent
} from "./components/ver-proyecto/fase-tramite-evaluacion/fase-tramite-evaluacion.component";
import {
    SolicitudEvaluacionesComponent
} from "../../officials/evaluaciones/components/solicitud-evaluaciones/solicitud-evaluaciones.component";
import {LeafletMapComponent} from "./components/nuevo-proyecto/components/leaflet-map/leaflet-map.component";
import {
    DisplayRegistroProfesionalComponent
} from "./components/ver-proyecto/display-registro-profesional/display-registro-profesional.component";
import {
    DisplayAntecedentesComponent
} from "./components/ver-proyecto/display-antecedentes/display-antecedentes.component";
import {ResolucionesComponent} from './components/ver-proyecto/resoluciones/pages/resoluciones/resoluciones.component';
import {
    DisplayTramitesExclusionComponent
} from './components/ver-proyecto/display-tramites-exclusion/display-tramites-exclusion.component';
import {
    InformacionGeneralClienteComponent
} from "./components/ver-proyecto/informacion-general-cliente/informacion-general-cliente.component";
import {EditorObservacionesComponent} from './components/editor-observaciones/editor-observaciones.component';
import {FormsModule} from '@angular/forms';
import {EditorModule} from 'primeng/editor';
import {PhoneFormatPipe} from "../../shared/pipes/PhoneFormatPipe";
import {DateFilterComponent} from "../../officials/dashboard/components/date-filter/date-filter.component";
import {RpCreateDlgComponent} from "../registro-profesionales/components/rp-create-dlg/rp-create-dlg.component";
import {
    NotificacionesEvaluacionComponent
} from "../../officials/evaluaciones/components/notificaciones-evaluacion/notificaciones-evaluacion.component";
import {
    TagInformativoTramiteExpresComponent
} from "../tramites/components/tramites-disponibles/dialog-tramites-expres/tag-informativo-tramite-expres/tag-informativo-tramite-expres.component";
import {
    DialogAsignarProfesionalesComponent
} from "src/app/users/registro-profesionales/components/dialog-asignar-profesionales/dialog-asignar-profesionales.component";
import {
    SubirResolucionComponent
} from "./components/ver-proyecto/resoluciones/components/subir-resolucion/subir-resolucion.component";
import {
    DialogCambiarRegistroComponent
} from "./components/ver-proyecto/generales-proyecto/dialog-cambiar-registro/dialog-cambiar-registro.component";
import {
    EliminarArchivoDlgComponent,
} from "./components/ver-proyecto/eliminar-archivo-dlg/eliminar-archivo-dlg.component";


@NgModule({
    declarations: [
        ListaProyectosComponent,
        InfoServiciosProyectoComponent,
        NuevoProyectoComponent,
        GeneralidadesNuevoProyectoComponent,
        UbicacionProyectoComponent,
        PersonasProyectoComponent,
        VerProyectoComponent,
        TramitesPorProyectoComponent,
        EditorObservacionesComponent,

    ],
    imports: [
        CommonModule,
        ProyectosRoutingModule,
        PrimeNgModule,
        PerfilModule,
        SharedModule,
        MenuModule,
        RippleModule,
        GeneralesProyectoComponent,
        AssignedUsersComponent,
        InputGroupModule,
        InputGroupAddonModule,
        InputSwitchModule,
        GeneralesResumenComponent,
        EventsBoardComponent,
        SkeletonModule,
        PdfJsViewerModule,
        InfoDialogRequisitosComponent,
        RequisitosInformacionComponent,
        SolicitudRequisitosComponent,
        ArchivoVigenteComponent,
        UsuarioDialogComponent,
        IconFieldModule,
        InputIconModule,
        ViewerImgComponent,
        ViewerPdfComponent,
        KeyFilterModule,
        PasosPersonasProyectosComponent,
        ConfirmPopupModule,
        StyleClassModule,
        DictamenesEvaluacionComponent,
        KnopComponent,
        FaseTramiteEvaluacionComponent,
        SolicitudEvaluacionesComponent,
        ResolucionesComponent,
        LeafletMapComponent,
        DisplayRegistroProfesionalComponent,
        DisplayAntecedentesComponent,
        DisplayTramitesExclusionComponent,
        InformacionGeneralClienteComponent,
        FormsModule,
        EditorModule,
        PhoneFormatPipe,
        DateFilterComponent,
        RpCreateDlgComponent,
        NotificacionesEvaluacionComponent,
        TagInformativoTramiteExpresComponent,
        DialogAsignarProfesionalesComponent,
        SubirResolucionComponent,
        DialogCambiarRegistroComponent,
        EliminarArchivoDlgComponent,
        EliminarArchivoDlgComponent
    ],
    exports: [
        NuevoProyectoComponent,
        ListaProyectosComponent,
        InfoServiciosProyectoComponent,
        TramitesPorProyectoComponent
    ],
    providers: [FileUtilsService, FormGroupBuilderService, FieldsParserService, DraftProjectService]
})
export class ProyectosModule {
}
